import { setField } from '../State/form'

export default (field, value) => (dispatch) => {

  dispatch(setField({ [field]: value }))

}
